import { DateInputForm, StackGrid, SwitchForm } from "@styleguide";
import { useMemo } from "react";
import { type Control, useWatch } from "react-hook-form";
import { jobSituations } from "../../logics/constants";
import type { IModalActionForm, IModalActionResolver } from "../../logics/types";

export interface IModalActionFormNextFollowUpProps {
  control: Control<IModalActionForm, void, IModalActionResolver>;
}

export const ModalActionFormNextFollowUp = ({ control }: IModalActionFormNextFollowUpProps) => {
  const jobSituation = useWatch({
    control,
    name: "jobFollowUp.jobSituation",
  });

  const displayNextFollowUp = useMemo(
    () => Boolean(jobSituations.find((option) => option.value === jobSituation)?.nextFollowUp),
    [jobSituation]
  );

  if (!displayNextFollowUp) {
    return null;
  }
  return (
    <>
      <SwitchForm
        control={control}
        name="jobFollowUp.nextFollowUpGenerate"
        label="Souhaitez-vous générer une nouvelle action de suivi en emploi ?"
      />
      <StackGrid perLine={2} rowGap={2} columnGap={2} strict>
        <DateInputForm
          control={control}
          name="jobFollowUp.nextFollowUpDate"
          label="Date du prochain suivi"
          TextFieldProps={{ size: "small" }}
        />
      </StackGrid>
    </>
  );
};
